import { render } from "./PurchaseItemModal.vue?vue&type=template&id=782d156c"
import script from "./PurchaseItemModal.vue?vue&type=script&lang=js"
export * from "./PurchaseItemModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__